export default (params) => `
  <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:web="http://webservice/">
    <soapenv:Header/>
    <soapenv:Body>
      <web:getPrice>
        <serviceType>${params.serviceType}</serviceType>
        <serviceProviderId>${params.serviceProviderId}</serviceProviderId>
        <sourceCountryId>${params.sourceCountryId}</sourceCountryId>
        <destinationCountryId>${params.destinationCountryId}</destinationCountryId>
        <payingCurrencyId>${params.payingCurrencyId}</payingCurrencyId>
        <payoutCurrencyId>${params.payoutCurrencyId}</payoutCurrencyId>
        <payingAmount>${params.payingAmount}</payingAmount>
        <payoutAmount>${params.payoutAmount}</payoutAmount>
        <payoutBranchCode>${params.payoutBranchCode}</payoutBranchCode>
        <userId>${params.userId}</userId>
        <userKey>${params.userKey}</userKey>
      </web:getPrice>
    </soapenv:Body>
  </soapenv:Envelope>
`